/**
 * Converts a string to a consistent color, optionally allowing HSL adjustments.
 * @param str The string to convert to a color.
 * @param options Optional settings for saturation and lightness.
 * @param options.saturation Saturation percentage (0-100). Default is calculated.
 * @param options.lightness Lightness percentage (0-100). Default is calculated.
 * @returns An HSL color string.
 */
export function stringToColor(
  str: string, 
  options?: { saturation?: number; lightness?: number }
): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }

  const hue = Math.abs(hash) % 360;
  const saturation = options?.saturation ?? (Math.abs(hash * 7) % 25) + 70; // Default 70-95% (more intense)
  const lightness = options?.lightness ?? (Math.abs(hash * 13) % 10) + 30; // Default 30-40% (much darker)

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
} 